module.exports = __webpack_public_path__ + "static/media/intro_icon_3.b2b1cdfe.svg";